import { useEnvironment } from '@/shared/composables'
import HttpService from '../HttpService'
import {
  type GetTravelPricePayload,
  type GetTravelPriceResponse,
  type GetTravelQuoteUaeResponse,
  PromoCodeTypes,
} from '@/shared/types/api.types'
import { i18n } from '@/app/plugins/i18n'

export class QuoteService extends HttpService {
  getTravelQuoteUae(
    promocode?: string,
    fullquote: 0 | 1 = 0,
    countries?: string[],
    type?: PromoCodeTypes
  ): Promise<GetTravelQuoteUaeResponse> {
    const countriesList = countries?.length ? { countries: countries?.join(',') } : {}
    const params = {
      fullquote,
      ...countriesList,
      ...(promocode && { promocode }),
      ...(type && { type }),
    }
    return this.get<GetTravelQuoteUaeResponse>('/gettravelquote', { params })
  }

  // TODO: rename from UAE
  async getTravelPriceUae(
    quoteno: string,
    schemecode: string,
    productcode: string,
    ids?: any[],
    selectproduct: 0 | 1 = 0
  ): Promise<any> {
    const formData = new FormData()
    formData.append('quoteno', quoteno)
    formData.append('schemecode', schemecode)
    formData.append('productcode', productcode)

    ids?.forEach((id) => formData.append('ids[]', id))
    formData.append('selectproduct', String(selectproduct))

    return await this.post('/gettravelprice', formData)
  }

  getTravelTotalPrice(payload: GetTravelPricePayload) {
    const { isDevelopment } = useEnvironment()
    const locale = i18n.global.locale

    let requestData = payload

    if (isDevelopment.value) {
      const redirectCode = locale.value === 'en' ? 'travelqatarsuccess' : 'travelqatarsuccessar'
      requestData = { ...payload, redirectPageCode: redirectCode }
    }
    return this.post<GetTravelPriceResponse>('gettraveltotalprice', requestData)
  }
}
